import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Header from "../components/header/Header";
import ProgressBar from "../components/progressBar/ProgressBar";
import "react-phone-input-2/lib/style.css";
import { FaArrowRight } from "react-icons/fa";
import { addToCart } from "../redux/actions/CartActions";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../components/loader/Loader";

// Validation schema
const validationSchema = Yup.object({
  businessName: Yup.string().required("Le nom de l'entreprise est requis"),
});

function ManagerBusinessName() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentStep = "Entreprise";
  const steps = [
    "Propriétaire",
    "Entreprise",
    "Services",
    "Paiement",
    "Finalisation",
  ];
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (values) => {
    setSubmitting(true);
    await dispatch(
      addToCart({
        managerName: values.businessName,
      })
    );

    navigate("/owner-marital-status");
  };

  return (
    <div style={{ backgroundColor: "#fff", paddingBottom: "40px" }}>
      <Header />
      <ProgressBar steps={steps} currentStep={currentStep} />
      <Loader isLoading={submitting} />

      {/* Title Section */}
      <div className="container mt-4 mb-4 text-center">
        <h4 className="text-2xl font-semibold">
          Quel est le{" "}
          <span style={{ color: "#FF5500" }}>nom de l'entreprise</span> qui sera
          la gérante de l'entreprise ? ?
        </h4>
      </div>

      {/* Form Section */}
      <div className="container mt-4 d-flex justify-content-center">
        <Formik
          initialValues={{
            businessName: "",
          }}
          validationSchema={validationSchema}
          onSubmit={async (values) => {
            handleSubmit(values);
          }}
        >
          {({ setFieldValue, errors, touched, values }) => (
            <Form className="w-100" style={{ maxWidth: "500px" }}>
              <div className="mb-3">
                <Field
                  name="businessName"
                  className="form-control"
                  placeholder="Nom de l'entreprise"
                  style={{ height: "50px" }}
                />
                {errors.businessName && touched.businessName && (
                  <div className="text-danger">{errors.businessName}</div>
                )}
              </div>

              <div className="d-flex justify-content-center mt-4">
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{
                    backgroundColor: "#051259",
                    borderRadius: "10px",
                    color: "#fff",
                    width: "180px",
                    padding: "10px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  Suivant
                  <FaArrowRight style={{ marginLeft: "8px" }} />
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default ManagerBusinessName;
